/* eslint-disable @typescript-eslint/no-explicit-any */
import {PanoramaFishEyeOutlined} from '@mui/icons-material';
import {Box, Button, Typography} from '@mui/material';
import {useRef} from 'react';
import Webcam from 'react-webcam';

export interface CaptureProps {
  onComplete: (data: string) => void;
}
export const CapturePhoto = ({onComplete}: any) => {
  const webcamRef = useRef<any>(null);
  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    onComplete(imageSrc);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        // width: '100vw',
        overflow: 'hidden',
        mt: '30px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          position: 'relative',
        }}
      >
        <PanoramaFishEyeOutlined
          sx={{
            fontSize: {
              xs: '180px',
              sm: '230px',
              md: '400px',
              xl: '500px',
              xxl: '600px',
            },
            color: '#3E82BF',
            position: 'absolute',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            width: {
              xs: '70%', // < 768px: 100%
              md: '60%', // >= 768px: 75%
              lg: '50%', // >= 1024px: 50%
            },
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            style={{width: '100%'}}
            videoConstraints={{
              width: 1280,
              height: 720,
              facingMode: 'user',
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          padding: '1vh',
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          fontWeight="fontWeightBold"
          textAlign="center"
          color="#3E82BF"
          paddingX="40px"
        >
          To start check in/out process, take a picture while your face is
          within the circle
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#3E82BF',
            color: 'white',
            boxShadow: 3,
            alignSelf: 'center',
            mt: 2,
          }}
          onClick={capture}
        >
          <Typography variant="h4">Press Here To Take Photo</Typography>
        </Button>
      </Box>
    </Box>
  );
};
